import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Section } from 'components/general-styles/General'
import { Grid, Col } from 'components/grid'

import { myths } from './data'
import * as S from './styles'

const Myths: FC = memo(() => (
  <Section>
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.ImageMobWrapper>
          <S.ImageMob>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home-equity/reading.png`}
              alt="Mulher analisando papéis"
              width="324"
              height="173"
              sizes="100vw"
              style={{
                width: '100%',
                height: 'auto'
              }}
            />
          </S.ImageMob>
        </S.ImageMobWrapper>

        <S.Infos>
          <Text className="subtitle" size="caption" weight="medium" uppercase>
            Entenda mais
          </Text>

          <Text as="h2" size="heading3" weight="medium">
            <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
              Mitos
            </Text>{' '}
            sobre o Home equity
          </Text>

          <Text color="var(--colors-neutral-text-weak)">
            A CashMe tem muita experiência na oferta de empréstimo com garantia de imóvel e, por isso, consegue praticar
            as melhores condições do mercado. Assim, cada vez mais pessoas estão recorrendo a esse tipo de crédito para
            realizar seus projetos. Para combater a desinformação, vamos falar sobre alguns mitos relacionados ao Home
            Equity.
          </Text>
        </S.Infos>

        <S.MythList>
          {myths.map(({ id, title, description }) => (
            <S.Card key={id}>
              <Text as="h3" size="heading4" weight="medium">
                {title}
              </Text>
              {description}
            </S.Card>
          ))}
        </S.MythList>
      </Col>
    </Grid>
  </Section>
))

Myths.displayName = 'Myths'

export default Myths
